import styled, { css } from 'styled-components'
import ContainerComponent from '@mui/material/Container'

export const Container = styled(ContainerComponent)(
  ({ theme }) => css`
    && {
      max-width: 100%;
      width: 100%;
      display: flex;
      flex-direction: column;
      align-items: flex-start;
      justify-content: flex-start;
      gap: ${theme.layout.gap.big};

      @media (max-width: ${theme.screen.small}) {
        padding-left: ${theme.layout.padding.medium};
        padding-right: ${theme.layout.padding.medium};
      }
    }
  `
)
